import { Grid, TextField, InputAdornment } from "@mui/material";
import { regexConstants } from "../../../constants/regEx";
import { numberWithCommas } from "../../../utils";
import { FixedTableConditionsTable } from "../../elements";

export default function FixedTableConditions({ data, onFieldChange, error, setError, modeType }) {
  return (
    <>
      {data?.is_pbh_fixed_table ? <FixedTableConditionsTable data={data} onFieldChange={onFieldChange} error={error} setError={setError} modeType={modeType} rateLabel="Rental Rate" dailyLabel="Daily Rent" /> : null}
      {data?.fixed_rate ? <Grid container spacing={2} sx={{ mt: 1 }}>
        <Grid size={{ md: 3, xs: 12 }}>
          <TextField
            required
            id="amount"
            value={modeType === 'view' && data?.amount !== '' && data?.amount !== null && data?.amount !== undefined ? numberWithCommas(data?.amount) : (data?.amount ? data?.amount : '')}
            onChange={(e) => { regexConstants.decimalnodotstart.test(e.target.value) ? onFieldChange('amount', e.target.value) : e.preventDefault() }}
            label="Rate / Unit"
            variant="outlined"
            size="small"
            margin="normal"
            error={!!error?.amount}
            helperText={error?.amount}
            onFocus={() => setError(prev => ({ ...prev, amount: "" }))}
            slotProps={{ inputLabel: { shrink: true }, htmlInput: { maxLength: 11 }, input: { startAdornment: (<InputAdornment position="start">{data?.currency?.symbol}</InputAdornment>) } }}
            fullWidth
            disabled={modeType === 'view'}
          />
        </Grid>
      </Grid> : null}
    </>
  );
}
